import React from 'react';
import { useTranslation } from 'react-i18next';
import ImageWithBasePath from '../../../../components/Common/imageWithBasePath';
import Badge from '../../../../components/Common/ui/Badge';

interface StudentInfoCardProps {
  student: {
    user: {
      firstName: string;
      lastName: string;
      photo?: string;
    };
    class?: {
      name: string;
    };
  };
  absenceStats: {
    totalHours: number;
    excusedHours: number;
    pendingHours: number;
    excusedPercentage: number;
    pendingPercentage: number;
  };
}

const StudentInfoCard: React.FC<StudentInfoCardProps> = ({ student, absenceStats }) => {
  const { t } = useTranslation();
  const studentName = `${student.user.firstName} ${student.user.lastName}`;
  
  return (
    <div className="card">
      <div className="card-body">
        <div className="text-center mb-4">
          <div className="avatar avatar-xl mb-3">
            <ImageWithBasePath
              src={student.user.photo || 'assets/img/profiles/avatar-01.jpg'}
              alt={studentName}
              className="avatar-img rounded-circle"
              width={50}
            />
          </div>
          <h4 className="mb-1">{studentName}</h4>
          <p className="text-muted">{student.class?.name}</p>
        </div>

        <div className="border-top pt-3">
          <div className="row text-center">
            <div className="col-4">
              <h5>{absenceStats.totalHours}</h5>
              <small className="text-muted">{t('total_hours')}</small>
            </div>
            <div className="col-4">
              <h5>{absenceStats.excusedHours}</h5>
              <small className="text-success">{t('excused')}</small>
            </div>
            <div className="col-4">
              <h5>{absenceStats.pendingHours}</h5>
              <small className="text-warning">{t('pending')}</small>
            </div>
          </div>
        </div>

        <div className="mt-4">
          <div className="progress mb-2" style={{ height: '10px' }}>
            <div
              className="progress-bar bg-success"
              role="progressbar"
              style={{ width: `${absenceStats.excusedPercentage}%` }}
              aria-valuenow={absenceStats.excusedPercentage}
              aria-valuemin={0}
              aria-valuemax={100}
            ></div>
            <div
              className="progress-bar bg-warning"
              role="progressbar"
              style={{ width: `${absenceStats.pendingPercentage}%` }}
              aria-valuenow={absenceStats.pendingPercentage}
              aria-valuemin={0}
              aria-valuemax={100}
            ></div>
          </div>
          <div className="d-flex justify-content-between small">
            <div className="d-flex align-items-center">
              <span
                className="d-inline-block bg-success rounded-circle me-2"
                style={{ width: '10px', height: '10px' }}
              />
              {t('excused')}: {absenceStats.excusedPercentage}%
            </div>
            <div className="d-flex align-items-center">
              <span
                className="d-inline-block bg-warning rounded-circle me-2"
                style={{ width: '10px', height: '10px' }}
              />
              {t('pending')}: {absenceStats.pendingPercentage}%
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentInfoCard;
